<template>
  <div class="content">
    <div class="wrapper-features">
      <p class="features">NAJWAŻNIEJSZE CECHY <strong>VOCALE Tripod</strong></p>
      <div class="main-features">
        <img src="@/assets/images/Tripod/image002.png" alt="">
        <img src="@/assets/images/Tripod/image004.png" alt="">
        <img src="@/assets/images/Tripod/image006.png" alt="">
        <img src="@/assets/images/Tripod/image008.png" alt="">
        <img src="@/assets/images/Tripod/image010.png" alt="">
      </div>
    </div>
    <div class="section-1">
      <img src="@/assets/images/Tripod/image012.png" alt="">
      <div class="description">
        <h1 class="font-size-big title">VOCALE Tripod</h1>
        <img src="@/assets/images/Tripod/image013.png" alt="">
      </div>
    </div>

    <div class="section-2">
      <h1 class="font-size-big title">Antypoślizgowy uchwyt zabezpiecza przed upadkiem</h1>
      <p class="font-size-middle">Centralna część oraz uchwyty boczne wyposażone w antypoślizgową 
        gumową podkładkę zwiększającą tarcie, co zapobiega zsuwaniu się tabletu oraz chroni 
        przed uszkodzeniem urządzenia.</p>
      <img src="@/assets/images/Tripod/image015.png" alt="">
    </div>

    <div class="section-3">
      <h1 class="font-size-big title">Stabilny statyw</h1>
      <p class="font-size-middle">Statyw <strong>VOCALE Tripod</strong> został specjalnie 
      zaprojektowany aby zapewnić największą stabilność dzięki rozłożystym nogą.</p>
      <img src="@/assets/images/Tripod/image017.png" alt="">
    </div>

    <div class="section-4">
      <h1 class="font-size-big title">Vocale Tripod <span>z bliska</span></h1>
      <img src="@/assets/images/Tripod/image019.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tripod',
}
</script>

<style lang='scss' scoped>
@import '@/assets/scss/_variables.scss';


.content {

  .title {
    color: $primary;
    font-weight: normal;
  }

  .description {
    font-size: 24px;
  }

  .wrapper-features {
    margin: 45px auto 90px;
    width: fit-content;

    .features {
      font-weight: normal;
      margin-bottom: 40px;
      & > strong {
        color: $primary
      }
    }
    .main-features {
      & > img {
        max-width: 100px;
        margin-right: 20px;
      }

      & > img:first-child {
        margin-left: 20px;
      }

      & > img:last-child {
        margin-right: 0;
      }
    }
  }

  .section-1 {
    display: flex;
    margin-left: 50px;
    & > img {
      max-width: 700px;
    }

    .description {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-bottom: 80px;
      padding-left: 50px;
      .title {
        margin: 0.67em;
        margin-bottom: 1em;
      }

      & > img {
        max-width: 155px;
      }
    }
  }

  .section-2 {
    margin-top: 100px;

    & > h1 {
      max-width: 700px;
      margin: 0.67em auto;
    }

    & > p {
      width: 920px;
      margin: 0 auto 40px;
      strong {
        color: $primary;
        font-weight: normal;
      }
    }

    img {
      max-width: 800px;
    }
  }

  .section-3 {
    margin-top: 100px;

    & > p {
      width: 927px;
      margin: 0 auto 60px;

      strong {
        color: $primary;
        font-weight: normal;
      }
    }

    img {
      max-width: 800px;
    }
  }

  .section-4 {
    margin-top: 120px;
    margin-bottom: 60px;

    & > h1 > span {
      color: white
    }

    & > p {
      width: 912px;
      margin: 0 auto 50px;
      strong {
        color: $primary;
        font-weight: normal;
      }
    }

    img {
      max-width: 800px;
    }
  }
}

@media screen and (max-width: 1280px) and (-webkit-min-device-pixel-ratio: 1.1) {

  .content {
    .wrapper-features {
      margin: 20px auto 20px;
      width: fit-content;

      .features {
        font-weight: normal;
        text-align: center;
        margin-bottom: 30px;
        & > strong {
          color: $primary
        }
      }
      .main-features {
        display: block;
        text-align: center;
        & > img {
          width: 16%;
          min-width: 40px;
          margin-right: 10px;
        }

        & > img:first-child {
          margin-left: 0;
        }

        & > img:last-child {
          margin-right: 0;
        }
      }
    }

    .section-1 {
      flex-direction: column;
      margin-left: 0;
      margin-top: 30px;
      align-items: center;

      & > img {
        width: 280px;
      }
      .description {
        margin-top: 15px;
        padding: 0;
        img {
          width: 123px;
          margin: 0 auto;
        }
      }
    }

    .section-4 {
      margin-bottom: 30px;
    }

    .section-2, .section-3, .section-4 {
      margin-top: 50px;
    }

    .section-1, .section-2, .section-3, .section-4 {
      p {
        width: 100%;
      }
    }

    img {
      width: 280px;
    }
  }
}

@media screen and (max-width: $phone-max-width) {

  .content {
    .wrapper-features {
      margin: 20px auto 20px;
      width: fit-content;

      .features {
        font-weight: normal;
        text-align: center;
        margin-bottom: 30px;
        & > strong {
          color: $primary
        }
      }
      .main-features {
        display: block;
        text-align: center;
        & > img {
          width: 16%;
          min-width: 40px;
          margin-right: 10px;
        }

        & > img:first-child {
          margin-left: 0;
        }

        & > img:last-child {
          margin-right: 0;
        }
      }
    }

    .section-1 {
      flex-direction: column;
      margin-left: 0;
      margin-top: 30px;
      align-items: center;

      & > img {
        width: 280px;
      }
      .description {
        margin-top: 15px;
        padding: 0;
        img {
          width: 123px;
          margin: 0 auto;
        }
      }
    }

    .section-4 {
      margin-bottom: 30px;
    }

    .section-2, .section-3, .section-4 {
      margin-top: 50px;
    }

    .section-1, .section-2, .section-3, .section-4 {
      p {
        width: 100%;
      }
    }

    img {
      width: 280px;
    }
  }
}

@media screen and (min-width: 600px) and (max-width: 1024px)  {
  .content {

    .wrapper-features {
      .main-features {
        & > img {
          margin-right: 20px;
        }

        & > img:first-child {
          margin-left: 20px;
        }

        & > img:last-child {
          margin-right: 0;
        }
      }
    }
    
    .section-1 {
      flex-direction: row;
      justify-content: center;

      & > img {
        width: 450px;
      }
    }

    img {
      width: 400px;
    }
  }
}

</style>